import {
  TABLE_ADMIN_FEATURE_MINIMUM_TERM_CONTRACT,
  TABLE_ADMIN_FEATURE_TYPOGRAPHIC_FIDELITY,
} from "../../i18n/keysTranslations";

export const FEATURE_FLAG_STORAGE = {
  ADVERTISER: "advertiser",
  AGENCY: "agency",
  AGENCIES_FEATURE_FLAGS: "agenciesFeatureFlags",
};

export const FEATURE_FLAG_ROW_KIND = {
  ADVERTISER: "advertiser",
  AGENCY: "agency",
};

export const FEATURE_FLAGS = [
  {
    key: "requiresTypographicFidelity",
    labelKey: TABLE_ADMIN_FEATURE_TYPOGRAPHIC_FIDELITY,
    storage: FEATURE_FLAG_STORAGE.ADVERTISER,
    hiddenFromOwner: true,
  },
  {
    key: "hasMinimumTermContractClause",
    labelKey: TABLE_ADMIN_FEATURE_MINIMUM_TERM_CONTRACT,
    storage: FEATURE_FLAG_STORAGE.AGENCY,
    defaultEnabled: true,
  },
];

const FEATURE_FLAGS_BY_KEY = Object.fromEntries(
  FEATURE_FLAGS.map((flag) => [flag.key, flag])
);

export const getFeatureFlagByKey = (key) => FEATURE_FLAGS_BY_KEY[key] || null;

export const getOwnerVisibleFeatureFlags = () =>
  FEATURE_FLAGS.filter((flag) => flag.hiddenFromOwner !== true);

export const getFeatureFlagsFormDefaults = () =>
  Object.fromEntries(
    getOwnerVisibleFeatureFlags().map((flag) => [
      flag.key,
      flag.defaultEnabled === true,
    ])
  );

export const getEnabledFeatureFlagsPayload = (featureFlags = {}) => {
  const enabled = {};

  getOwnerVisibleFeatureFlags().forEach((flag) => {
    if (featureFlags?.[flag.key] === true) {
      enabled[flag.key] = true;
    }
  });

  return enabled;
};

export const getFeatureFlagsForRowKind = (rowKind) => {
  const visibleFlags = getOwnerVisibleFeatureFlags();

  if (rowKind === FEATURE_FLAG_ROW_KIND.AGENCY) {
    return visibleFlags.filter(
      (flag) => flag.storage !== FEATURE_FLAG_STORAGE.ADVERTISER
    );
  }

  return visibleFlags;
};

export const isFeatureFlagEnabled = ({
  flag,
  advertiser,
  agencyFlags = {},
  agencyID,
  agenciesFeatureFlags = {},
}) => {
  switch (flag?.storage) {
    case FEATURE_FLAG_STORAGE.ADVERTISER:
      return advertiser?.[flag.key] === true;
    case FEATURE_FLAG_STORAGE.AGENCY:
      return agencyFlags?.[flag.key] === true;
    case FEATURE_FLAG_STORAGE.AGENCIES_FEATURE_FLAGS: {
      const ids = agenciesFeatureFlags?.[flag.key] ?? [];
      return Array.isArray(ids) && Boolean(agencyID) && ids.includes(agencyID);
    }
    default: {
      const _exhaustive = flag?.storage;
      void _exhaustive;
      return false;
    }
  }
};

export const getFeatureFlagsMenuOption = ({
  rowKind,
  labelKey,
  advertiser,
  advertiserID,
  agencyID,
  agencyFlags,
  agenciesFeatureFlags,
  onToggle,
  updating = null,
}) => {
  const flags = getFeatureFlagsForRowKind(rowKind);
  if (flags.length === 0) {
    return null;
  }

  const isUpdatingTarget =
    Boolean(updating) &&
    (updating.advertiserID || "") === (advertiserID || "") &&
    (updating.agencyID || "") === (agencyID || "");

  return {
    label: labelKey,
    submenu: flags.map((flag) => ({
      key: flag.key,
      label: flag.labelKey,
      type: "checkbox",
      checked: isFeatureFlagEnabled({
        flag,
        advertiser,
        agencyFlags,
        agencyID,
        agenciesFeatureFlags,
      }),
      loading: isUpdatingTarget && updating.key === flag.key,
      disabled: Boolean(updating),
      onChange: (enabled) =>
        onToggle({
          key: flag.key,
          enabled,
          advertiserID,
          agencyID,
        }),
    })),
  };
};
